import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import {
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  Typography,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Divider
} from '@material-ui/core';

import { shapes } from '@greenville/framework';
import { toJS } from 'mobx';
import { FormattedMessage } from 'react-intl';

import Users from '../models/Users';

import Roles from '../models/Roles';
import ValidatePermissions from '../ValidatePermissions';
import TooltipCustom from '../../../common/components/TooltipCustom';
import UsersPermissions from '../models/UsersPermissions';
import AllRoles from '../models/AllRoles';
import RoleDialog from './RoleDialog';
import { styles } from './UserStyle';
import * as constants from '../../../common/constants';
/* eslint-disable */
/**
 * A Component for the display of the Course Card.
 *
 * @param data the title of the course
 * @param btnText the title of the course
 * @param lastName the title of the course
 * @param role the title of the course
 * @param edit the title of the course
 * @return {*} the React pure component
 * @constructor
 */

const columns = [
  {
    id: 'role',
    label: 'Role Name',
    columnWidth: '90px'
  },
  {
    id: 'description',
    label: 'Description',
    columnWidth: '100px',
    isWordBreak: true,
    align: 'left'
  },
  {
    id: 'permissions',
    label: 'Permissions',
    columnWidth: '250px',
    isWordBreak: true,
    align: 'left'
  },
  {
    id: 'action',
    label: 'EDIT',
    isClickableButton: true,
    columnWidth: '40px'
  }
];

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
const RoleList = ({
  classes,
  data,
  usersState,

  language,
  userPermissions,
  allRoles,
  setOpenRoleList
}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [showEditData, setshowEditData] = React.useState({});
  const permissionsList = toJS(userPermissions.permissionList.permissions);

  const [openNewRoleDialog, setOpenNewRoleDialog] = React.useState(false);
  // const [openRoleList, setOpenRoleList] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(true);
  const [editRole, setEditRole] = React.useState(false);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleEditData = (row) => {
    setOpenNewRoleDialog(true);
    setEditRole(true);
    setshowEditData(row);
  };

  React.useEffect(() => {
    // setFilteredData(data);
    // setSearchField('');
    allRoles.fetch();
  }, [data]);

  const closeRoleDialog = () => {
    setOpenNewRoleDialog(false);
  };
  const handleClose = () => {
    setOpenRoleList(false);
    setOpenNewRoleDialog(false);

    setshowEditData({}); // Clear previous data
  };
  const saveRole = (rolesData) => {
    usersState.updateRoles(rolesData);
    setOpenNewRoleDialog(false);
    handleClose();
  };

  return (
    <ValidatePermissions givenPermissions="user_can_view">
      <>
        <Dialog fullWidth="true" maxWidth="md" open={openDialog} onClose={handleClose} TransitionComponent={Transition}>
          <AppBar className={classes.appBar} color="primary">
            <Toolbar>
              <Typography variant="h3" className={classes.title}>
                Role List
              </Typography>
              <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Divider className={classes.divider} />
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align || 'left'}
                      className={classes.tableStyle}
                      style={{
                        width: column.columnWidth,
                        minWidth: column.columnWidth,
                        wordBreak: column.isWordBreak ? 'break-word' : 'normal',
                        whiteSpace: column.isWordBreak ? 'normal' : 'nowrap',
                        overflowWrap: column.isWordBreak ? 'break-word' : 'normal',
                        fontWeight: 'bold'
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {allRoles.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => (
                  <TableRow hover role="checkbox" tabIndex={-1} key={`${row.id}-${i}`}>
                    {columns.map((column, index) => {
                      const value = row[column.id];
                      return (
                        <TableCell
                          key={`${column.id}-${index}`}
                          align={column.align || 'left'}
                          style={{
                            width: column.columnWidth,
                            minWidth: column.columnWidth,
                            wordBreak: column.isWordBreak ? 'break-word' : 'normal',
                            whiteSpace: column.isWordBreak ? 'normal' : 'nowrap',
                            overflowWrap: column.isWordBreak ? 'break-word' : 'normal'
                          }}
                        >
                          {column.id === 'action' ? (
                            <TooltipCustom
                              title={
                                !permissionsList.includes('user_can_edit') ? (
                                  <FormattedMessage {...language.getText('user.PERMISSIONS_LABEL')} />
                                ) : (
                                  <FormattedMessage {...language.getText('role.EDIT_DETAILS')} />
                                )
                              }
                            >
                              <Button
                                variant="outlined"
                                disabled={!permissionsList.includes('user_can_edit')}
                                size={column.size || 'small'}
                                color="primary"
                                onClick={() => handleEditData(row)}
                              >
                                {constants.EDIT}
                              </Button>
                            </TooltipCustom>
                          ) : column.format && typeof value === 'number' ? (
                            column.format(value)
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 200]}
            component="div"
            count={allRoles.data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Dialog>
        {openNewRoleDialog && (
          <RoleDialog
            closeRoleDialog={closeRoleDialog}
            editRole={editRole}
            showEditData={showEditData}
            saveRole={saveRole}
            setOpenNewRoleDialog={setOpenNewRoleDialog}
          />
        )}
      </>
    </ValidatePermissions>
  );
};

RoleList.propTypes = {
  data: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  updateBreadcrumbs: PropTypes.func.isRequired,
  pathUrl: PropTypes.func.isRequired,
  usersState: shapes.modelOf(Users).isRequired,
  userRoles: shapes.modelOf(Roles).isRequired,
  match: PropTypes.object.isRequired,
  addUserStatus: PropTypes.object.isRequired,
  editUserstatus: PropTypes.object.isRequired,
  userPermissions: shapes.modelOf(UsersPermissions).isRequired,
  allRoles: shapes.modelOf(AllRoles).isRequired,
  language: shapes.language.isRequired,
  setOpenRoleList: PropTypes.func.isRequired
};

export default withStyles(styles)(inject('language', 'userPermissions')(observer(RoleList)));
